export interface SseRequest {
  url: string;
  token: string;
  onEvent: (event: unknown) => void;
  body?: unknown;
  signal?: AbortSignal;
}

const DETAIL_MARKER = "Resposta recebida: ";

export function splitFailureDetail(message: string): {
  message: string;
  detail: string | null;
} {
  const at = message.indexOf(DETAIL_MARKER);
  if (at === -1) return { message, detail: null };

  return {
    message: message.slice(0, at).trim(),
    detail: message.slice(at + DETAIL_MARKER.length).trim() || null,
  };
}

export async function readSseStream({
  url,
  token,
  onEvent,
  body,
  signal,
}: SseRequest): Promise<void> {
  const response = await fetch(url, {
    method: body === undefined ? "GET" : "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body === undefined ? {} : { "Content-Type": "application/json" }),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
    signal,
  });

  if (!response.ok || !response.body) {
    throw new Error(`Falha ao abrir o stream (${response.status})`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });

    let boundary = buffer.indexOf("\n\n");
    while (boundary !== -1) {
      const chunk = buffer.slice(0, boundary);
      buffer = buffer.slice(boundary + 2);

      const line = chunk.split("\n").find((l) => l.startsWith("data: "));
      if (line) {
        try {
          onEvent(JSON.parse(line.slice(6)));
        } catch {
          onEvent({ type: "error", message: "Evento malformado no stream." });
        }
      }

      boundary = buffer.indexOf("\n\n");
    }
  }
}
